import React from "react";
import ReactApexChart from "react-apexcharts";
import Utils from "Utils/utils";
import { getNiceMax } from "../utils/chartDataUtils";

const COLOR = "#16a34a";

const CallsByMemberWidget = ({ callsByMember = [], visualization }) => {
  if (!callsByMember.length) {
    return <p className="callOutcomesEmpty">No calls by member data</p>;
  }

  const memberNames = callsByMember.map(m => m.name || "Unknown");
  const callsMadeCounts = callsByMember.map(m => m.callsMade || 0);
  const { max: niceMax, tickAmount } = getNiceMax(Math.max(...callsMadeCounts, 1));

  const isKpi = visualization === "KPI";
  const isLine = visualization === "LINE";
  const isBar = !isLine && !isKpi;

  if (isKpi) {
    return (
      <div className="widgetCardNumericSummary">
        {callsByMember.map((m, i) => (
          <div key={`${m.name || "Unknown"}-${i}`} className="widgetCardNumericSummaryRow">
            <span className="widgetCardNumericSummaryLabel">{memberNames[i]}</span>
            <span className="widgetCardNumericSummaryValue">{Utils.formatNumberToStringInUSFormat(m.callsMade || 0)}</span>
          </div>
        ))}
      </div>
    );
  }

  const options = {
    chart: {
      type: isLine ? "area" : "bar",
      toolbar: { show: false },
      animations: { enabled: false },
      selection: { enabled: false },
      zoom: { enabled: false }
    },
    ...(isLine
      ? {
          stroke: { show: true, curve: "smooth", width: 2, colors: [COLOR] },
          markers: { size: 4, colors: [COLOR], strokeColors: "#fff", strokeWidth: 2, hover: { size: 5 } },
          fill: { type: "solid", opacity: 0.2 }
        }
      : {
          plotOptions: { bar: { borderRadius: 3, columnWidth: "55%", distributed: true } }
        }),
    colors: [COLOR],
    dataLabels: { enabled: false },
    legend: { show: false },
    xaxis: {
      categories: memberNames,
      labels: { show: false },
      axisBorder: { show: false },
      axisTicks: { show: false },
      tooltip: { enabled: false }
    },
    yaxis: {
      min: 0,
      max: niceMax,
      tickAmount,
      labels: {
        formatter: val => Math.round(val),
        style: { fontSize: "10px", colors: "#999" }
      }
    },
    grid: {
      borderColor: "#e8ebee",
      strokeDashArray: 3,
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: true } }
    },
    tooltip: {
      x: { show: true },
      y: {
        title: { formatter: () => "Calls Made:" },
        formatter: val => `${val}`
      }
    }
  };

  const series = [{ name: "Calls Made", data: callsMadeCounts }];
  const chart = (
    <ReactApexChart
      key={isLine ? "area" : "bar"}
      options={options}
      series={series}
      type={isLine ? "area" : "bar"}
      height={140}
      width="100%"
    />
  );

  return chart;
};

export default CallsByMemberWidget;
